<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('SALARIE')">
        <slot name="section-salarie">
          <section-salarie ref="SALARIE"
                           id="SALARIE"
                           :extended="isExtended('SALARIE')"
                           :showButton="true"
                           :autoSave="true"
                           :readOnly="readOnly"
                           :moduleId="moduleId"
                           :searchText="searchText"
                           :ressourceHeader="ressource"
                           :fiche="fiche"
                           :toggleResetCiviliteSelect="toggleResetCiviliteSelect"
                           :toggleResetEmploiSelect="toggleResetEmploiSelect"
                           :salarie=selectedSalarie
                           :route="route"
                           :attribut="attribut"
                           @extended="setExtended"
                           @fullscreen="setFullscreen"
                           @status="updateStatus"
                           @updated="salarieUpdated"
                           @selectItem = "selectItem">
          </section-salarie>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ADRESSE')">
        <slot name="section-adresse">
          <section-adresse ref="ADRESSE"
                           id="ADRESSE"
                           :extended="isExtended('ADRESSE')"
                           :showButton="true"
                           :autoSave="true"
                           :readOnly="readOnly"
                           :moduleId="moduleId"
                           :searchText="searchText"
                           :ressourceHeader="ressource"
                           :fiche="fiche"
                           :toggleResetPaysSelect="toggleResetPaysSelect"
                           :adresse=selectedAdresse
                           :route="route"
                           :attribut="attribut"
                           @extended="setExtended"
                           @fullscreen="setFullscreen"
                           @status="updateStatus"
                           @updated="adresseUpdated"
                           @selectItem = "selectItem">
          </section-adresse>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('SALARIE_CIVILITE')">
        <slot name="section-salarie-civilite">
          <section-salarie-civilite ref="SALARIE_CIVILITE"
                                    id="SALARIE_CIVILITE"
                                    :extended="isExtended('SALARIE_CIVILITE')"
                                    :showButton="true"
                                    :autoSave="true"
                                    :readOnly="readOnly"
                                    :moduleId="moduleId"
                                    :searchText="searchText"
                                    :ressourceHeader="ressource"
                                    :fiche="fiche"
                                    :toggleResetPaysSelect="toggleResetPaysSelect"
                                    :toggleResetPaysSelectNat="toggleResetPaysSelectNat"
                                    :salarie=selectedSalarie
                                    :route="route"
                                    :attribut="attribut"
                                    @extended="setExtended"
                                    @fullscreen="setFullscreen"
                                    @status="updateStatus"
                                    @updated="salarieUpdated"
                                    @selectItem = "selectItem">
          </section-salarie-civilite>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('SALARIE_INFORMATIONS')">
        <slot name="section-salarie-informations">
          <section-salarie-informations ref="SALARIE_INFORMATIONS"
                                        id="SALARIE_INFORMATIONS"
                                        :extended="isExtended('SALARIE_INFORMATIONS')"
                                        :showButton="true"
                                        :autoSave="true"
                                        :readOnly="readOnly"
                                        :moduleId="moduleId"
                                        :searchText="searchText"
                                        :ressourceHeader="ressource"
                                        :fiche="fiche"
                                        :salarie=selectedSalarie
                                        :route="route"
                                        :attribut="attribut"
                                        @extended="setExtended"
                                        @fullscreen="setFullscreen"
                                        @status="updateStatus"
                                        @updated="salarieUpdated"
                                        @selectItem = "selectItem">
          </section-salarie-informations>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('SALARIE_FISCALITE')">
        <slot name="section-salarie-fiscalite">
          <section-salarie-fiscalite ref="SALARIE_FISCALITE"
                                     id="SALARIE_FISCALITE"
                                     :extended="isExtended('SALARIE_FISCALITE')"
                                     :showButton="true"
                                     :autoSave="true"
                                     :readOnly="readOnly"
                                     :moduleId="moduleId"
                                     :searchText="searchText"
                                     :ressourceHeader="ressource"
                                     :fiche="fiche"
                                     :salarie=selectedSalarie
                                     :route="route"
                                     :attribut="attribut"
                                     @extended="setExtended"
                                     @fullscreen="setFullscreen"
                                     @status="updateStatus"
                                     @updated="salarieUpdated"
                                     @selectItem = "selectItem">
          </section-salarie-fiscalite>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('RIB')">
        <slot name="section-rib">
          <section-rib ref="RIB"
                       id="RIB"
                       :extended="isExtended('RIB')"
                       :showButton="true"
                       :autoSave="true"
                       :readOnly="readOnly"
                       :moduleId="moduleId"
                       :searchText="searchText"
                       :ressourceHeader="ressource"
                       :fiche="fiche"
                       :rib=selectedRib
                       :route="route"
                       :attribut="attribut"
                       @extended="setExtended"
                       @fullscreen="setFullscreen"
                       @status="updateStatus"
                       @updated="ribUpdated"
                       @selectItem = "selectItem">
          </section-rib>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Salarie from '@/extend/classes/Salarie';
import Adresse from '@/extend/classes/Adresse';
import { storeAdresse } from '@/generated/stores';
import Rib from '@/extend/classes/Rib';
import { storeRib } from '@/generated/stores';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionSalarie from '@/extend/sections/SectionSalarieExtend.vue';
import SectionAdresse from '@/extend/sections/SectionAdresseExtend.vue';
import SectionSalarieCivilite from '@/extend/sections/SectionSalarieCiviliteExtend.vue';
import SectionSalarieInformations from '@/extend/sections/SectionSalarieInformationsExtend.vue';
import SectionSalarieFiscalite from '@/extend/sections/SectionSalarieFiscaliteExtend.vue';
import SectionRib from '@/extend/sections/SectionRibExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionSalarie,
    SectionAdresse,
    SectionSalarieCivilite,
    SectionSalarieInformations,
    SectionSalarieFiscalite,
    SectionRib,
    FicheHeader,
  },

  props: {
    salarie: {
      type: Object as PropType<Salarie>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.SALARIE,
      sections: [
        'SALARIE',
        'ADRESSE',
        'SALARIE_CIVILITE',
        'SALARIE_INFORMATIONS',
        'SALARIE_FISCALITE',
        'RIB',
      ],

      toggleResetCiviliteSelect: false,
      toggleResetEmploiSelect: false,
      adresse: new Adresse(),
      toggleResetPaysSelect: false,
      toggleResetPaysSelectNat: false,
      rib: new Rib(),
    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_SALARIE);
    },

    selectedSalarie (): Salarie {
      return this.salarie
    },
    selectedAdresse (): Adresse {
      if (this.salarie.adresseId == 0) {
        return storeAdresse.createNewAdresse();
      } else {
        return storeAdresse.getAdresse(this.salarie.adresseId);
      }
    },

    selectedRib (): Rib {
      if (this.salarie.ribId == 0) {
        return storeRib.createNewRib();
      } else {
        return storeRib.getRib(this.salarie.ribId);
      }
    },

  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    salarieUpdated (salarie: Salarie) {
    // To implement
    },

    // eslint-disable-next-line
    adresseUpdated (adresse: Adresse) {
    // To implement
    },

    // eslint-disable-next-line
    ribUpdated (rib: Rib) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.salarie || this.salarie.id < 0) && value == 'SALARIE') {
        this.setExtended(new Extended('SALARIE', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
